import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-coral-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M17 16H7V18H17V16Z" fill={textColor} />
    <path d="M19 7H5V14H19V7Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M22.4001 19.52H9.6001V22.08H22.4001V19.52Z" fill={textColor} />
    <path d="M24.96 9.91992H7.04004V18.2399H24.96V9.91992Z" fill={textColor} />
  </>
);

export const HeadingIcon = createSlideIcon(Icon24x24, Icon32x32);
